import React from 'react'
import { ActionChip, Paragraph, ExpanderContent, Separator, ExpanderHeader, Expander } from '@fs/zion-ui'

import styles from './QualityTags.styles'
import trans from './QualityTags.transl'

export default function QualityTags({ comments, folderQTags, recordCaptureComment }) {
  function getComments(comment) {
    let processedComment = ''
    if (Array.isArray(comment?.values) && comment.values?.length > 0) {
      processedComment = comment?.values?.join('\n')
    }
    return processedComment
  }

  function getFolderQTags(qTag) {
    let processedQualityTags = []
    if (Array.isArray(qTag?.values) && qTag.values?.length > 0) {
      processedQualityTags = qTag?.values[0].split(';').filter(Boolean)
    }
    return processedQualityTags
  }

  return (
    <div css={styles.qualityTags}>
      <Expander>
        <ExpanderHeader>{trans.qualityTagsHeader()}</ExpanderHeader>
        <ExpanderContent>
          <Separator size="xs" />
          {getFolderQTags(folderQTags).map((qTag) => (
            <div css={styles.commentChips} key={qTag}>
              <ActionChip label={trans[`qualityTags${qTag}`]()} />
            </div>
          ))}
          <Separator size="xs" />
          <Paragraph>
            {getComments(comments)}
            {comments && <br />}
            {getComments(recordCaptureComment)}
          </Paragraph>
        </ExpanderContent>
      </Expander>
    </div>
  )
}
